module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1ODUgMTAyNCI+PHBhdGggZmlsbD0iIzhmZiIgZD0iTTU0OCAxNnYxNTAuODU3aC04OS43MTRxLTQ5LjE0MyAwLTY2LjI4NiAyMC41N3QtMTcuMTQzIDYxLjcxNXYxMDhoMTY3LjQzTDUyMCA1MjYuMjg1SDM3NC44NTdWOTYwSDIwMFY1MjYuMjg0SDU0LjI4NlYzNTcuMTQySDIwMHYtMTI0LjU3cTAtMTA2LjI4NyA1OS40My0xNjQuODU4dDE1OC4yODUtNTguNTdxODQgMCAxMzAuMjg2IDYuODU2eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ../static/img/svg-icons/facebook.svg
// module id = 410
// module chunks = 0